/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetStagedGachaResponse } from '../../models/get-staged-gacha-response';

export interface AdminServiceGetStagedGacha$Params {
}

export function adminServiceGetStagedGacha(http: HttpClient, rootUrl: string, params?: AdminServiceGetStagedGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStagedGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetStagedGacha.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetStagedGachaResponse>;
    })
  );
}

adminServiceGetStagedGacha.PATH = '/api/v3/gateway/admin/stage/gacha';
